// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".policies__section[data-v-0ba20f41]{margin-top:.5rem}.policies__title[data-v-0ba20f41]{color:#282c4a;color:rgba(40,44,74,var(--tw-text-opacity));font-weight:600}.policies__text[data-v-0ba20f41],.policies__title[data-v-0ba20f41]{font-size:.875rem;line-height:1.25rem;--tw-text-opacity:1}.policies__text[data-v-0ba20f41]{color:#64687e;color:rgba(100,104,126,var(--tw-text-opacity));margin-top:.5rem}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
